module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1ae165bd"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./~/_vue-awesome-swiper@2.6.7@vue-awesome-swiper/src/slide.vue
// module id = 219
// module chunks = 49